module.exports = __webpack_public_path__ + "img/content4.0d987e97.png";